import Vue from 'vue'
import {base} from './base.js'
/*
nGv: false - 没有V1、V2版本号
isLoading: true - 显示加载
*/
// 初始化
export function init () {
  return Vue.prototype.postAxios(base.INIT)
}
// 获取微信开发列表
export function getJsticket (url) {
  return Vue.prototype.postAxios(base.getJSLIST, {url})
}
// 获取分享设置
export function getShare (params) {
  return Vue.prototype.postAxios(base.GET_SHARE, params)
}
// 激活码激活课程
export async function activeCode (ac, ck) {
  const result = await Vue.prototype.postAxios(base.ACTIVE_CODE, {ac, ck}, {errData: true, isLoading: true})
  return result
}
// 渠道领取
export function activeByChannelKey (cc, bk, ck) {
  return Vue.prototype.postAxios(base.ACTIVE_BY_CHANNELKEY, {cc, bk, ck})
}
// 购买成功
export function paySuccess (order_id) {
  return Vue.prototype.postAxios(base.PAY_SUCCESS, {order_id})
}
// 获取二维码
export function getQrcode (type) {
  return Vue.prototype.postAxios(base.GET_QRCODE, {type}, {isLoading: true})
}
// 二维码识别次数
export function sQrcount (tag) {
  return Vue.prototype.postAxios(base.S_QRCOUNT, {tag})
}
// 初始化
export function initConfig () {
  return Vue.prototype.postAxios(base.INIT_CONFIG)
}
// 获取专栏列表
export async function getPackAge () {
  const result = await Vue.prototype.postAxios(base.PACKAGE_LIST)
  return result
}
// 获取专栏详情
export function packageInfo (pid) {
  return Vue.prototype.postAxios(base.PACKAGE_INFO, {pid})
}
// 专栏下的图书列表
export async function getBook (pid, page, list_rows) {
  const result = await Vue.prototype.postAxios(base.BOOK_LIST, {pid, page, list_rows}, {isLoading: true})
  return result
}
// 图书详情
export async function getBookInfo (pid, bid) {
  const result = await Vue.prototype.postAxios(base.BOOK_INFO, {pid, bid})
  return result
}
// 图书音频播放
export function playBook (pid, bid, baid) {
  return Vue.prototype.postAxios(base.BOOK_PLAY, {pid, bid, baid})
}
// 点赞榜列表
export async function getRankList (params) {
  // pid, bid, page, list_rows, year, month
  const result = await Vue.prototype.postAxios(base.RANK_LIST, params)
  return result
}
// 点赞榜基本信息
export async function getRankInfo (id, pId, year, month) {
  const bid = id || ''
  const pid = pId || ''
  const result = await Vue.prototype.postAxios(base.RANK_INFO, {bid, pid, year, month})
  return result
}
// 空间信息
export function getZoneInfo (uls) {
  return Vue.prototype.postAxios(base.ZONE_INFO, {uls})
}
// 获取我的空间列表
export async function getMomentList (uid, bookId, page) {
  const uls = uid || ''
  const bid = bookId || ''
  const result = await Vue.prototype.postAxios(base.MOMENT_LIST, {uls, bid, page})
  return result
}
// 获取Moment详情
export async function getMomentInfo (mid, id) {
  const uls = id || ''
  const result = await Vue.prototype.postAxios(base.MOMENT_INFO, {mid, uls}, {errData: true, isLoading: true})
  return result
}
// 设置动态为公开/私密
export function setPublic (mid, isp) {
  return Vue.prototype.postAxios(base.SET_PUBLIC, {mid, isp})
}
// 删除用户动态
export function delMoment (mid) {
  return Vue.prototype.postAxios(base.DEL_MOMENT, {mid})
}
// 发布用户动态
export function sendMoment (pid, bid, isp, type, media_ids) {
  return Vue.prototype.postAxios(base.SEND_MOMENT, {pid, bid, isp, type, media_ids})
}
// 点赞用户状态
export function setLike (mid) {
  return Vue.prototype.postAxios(base.SET_LIKE, {mid})
}
// 举报
export function report (type, rtype, other_str, mid, uls) {
  return Vue.prototype.postAxios(base.REPORT, {type, rtype, other_str, mid, uls})
}
// 获取配置
export function getConfig (params) {
  return Vue.prototype.postAxios(base.GET_CONFIG, params)
}



// WEBPACK FOOTER //
// ./src/api/book.js